import React, { useEffect, useState } from "react";
import Cell from "../components/Cell.jsx";
import AlertsSwiperCard from "../components/cards/AlertsSwiperCard.jsx";
import PublicContext from "../contexts/PublicContext.jsx";
import { SensorsMapProvider } from "../contexts/SensorsMapProvider.jsx";
import { getReportStats } from "../services/reportsService.js";
import { FaHourglassHalf, FaTools } from "react-icons/fa";
import SensorsOverviewCard from "../components/cards/SensorsOverviewCard.jsx";
import Map from "../components/map/Map.jsx";
import { LoopMapMonitor } from "../components/map/LoopMapMonitor.jsx";
import RadarCard from "../components/cards/RadarCard.jsx";

function MonitorPage() {
	const [reportStats, setReportStats] = useState();

	useEffect(() => {
		const fetchStats = () => getReportStats().then((res) => setReportStats(res.data.stats));

		fetchStats();
		const interval = setInterval(fetchStats, 60 * 1000);
		return () => clearInterval(interval);
	}, []);

	return (
		<PublicContext>
			<SensorsMapProvider>
				<div className="grid grid-cols-4 gap-4">
					<Cell
						cols={1}
						lgCols={2}
						xlCols={2}
						xlRows={2}
						style={{ height: "735px" }}
						className="col-span-1 lg:col-span-2 xl:col-span-2 row-span-1 xl:row-span-2 !p-0"
					>
						<Map isMonitor={true} />
						<LoopMapMonitor />
					</Cell>

					<Cell style={{ height: "370px" }}>
						<AlertsSwiperCard mode={"allarmeteo"} />
					</Cell>

					<Cell style={{ height: "370px" }}>
						<AlertsSwiperCard mode={"comune"} />
					</Cell>

					<Cell style={{ height: "350px" }} className=" text-center bg-red-50">
						<RadarCard />
					</Cell>

					<Cell style={{ height: "350px" }}>
						{reportStats && (
							<div className="space-y-3">
								{/* Pending Reports */}
								<div className="flex items-center justify-between p-2">
									<FaHourglassHalf className="text-yellow-500 mr-3" size={24} />
									<h2 className="text-lg font-bold text-gray-700 flex-1">
										Segnalazioni In Attesa
									</h2>
									<p className="text-3xl font-semibold text-gray-800 mr-0 2xl:mr-16">
										{reportStats.pending_reports}
									</p>
								</div>

								{/* Working Reports */}
								<div className="flex items-center justify-between p-2">
									<FaTools className="text-orange-500 mr-3" size={24} />
									<h2 className="text-lg font-bold text-gray-700 flex-1">
										Segnalazioni In Lavorazione
									</h2>
									<p className="text-3xl font-semibold text-gray-800 mr-0 2xl:mr-16">
										{reportStats.working_reports}
									</p>
								</div>

								{/* Closed Reports */}
								{/* <div className="flex items-center justify-between p-2">
									<FaCheckCircle className="text-green-500 mr-3" size={24} />
									<h2 className="text-lg font-bold text-gray-700 flex-1">
										Segnalazioni Risolte
										</h2>
									<p className="text-3xl font-semibold text-gray-800 mr-0 2xl:mr-16">
										{reportStats.closed_reports}
									</p>
								</div> */}
							</div>
						)}
						<SensorsOverviewCard />
					</Cell>
				</div>
			</SensorsMapProvider>
		</PublicContext>
	);
}

export default MonitorPage;
